import functions from '../functions';
import { Select2 } from '../components/select2';

$(() => {
    details.init();
})

const details = {
    $details: null,
    $form: null,
    form: null,
    params: {
        objectId: null, 
        unitId: null, 
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: null,
        calcErrorMessages: null,
    },
    init() {

        details.$details = $('.page-type-details');

        if(! details.$details[0]) {
            return;
        }

        $('[id^="requestModal"]').on('shown.bs.modal', e => {
            const $target = $(e.currentTarget);

            $target.find('.select2').each((i, elem) =>{
                elem._select2 = new Select2(elem);
            });
        });

        $('[id^=pricelistTableModal], [id^=pricelistSkiPassTableModal], [id^=pricelistPackageTableModal]').on('show.bs.modal', e => {
            const $target = $(e.currentTarget);
            let params = $target.attr('data-params') ? JSON.parse($target.attr('data-params')) : null;

            const $objectPricelist = $target.find('.object-pricelist-table');
            const $objectPricelistSpinner = $target.find('.object-pricelist-spinner');
 
            if(params && ! $objectPricelist.children().length) {
                $.get('/services/get_pricelists/', params).done(response => {

                    if (response) {
                        $objectPricelist.html(response);
                        $objectPricelistSpinner.addClass('d-none');
    
                        const $fixedTableContainer = $target.find('.add-table-fixed');
                
                        if($fixedTableContainer.length) {
                            const isMobile = functions.isMobile();
                            let noColumns = isMobile ? 2 : 10;
                    
                            let isFixed = $fixedTableContainer.find('.table-fixed').length;
                
                            if(! isFixed) {
                                const $table = $fixedTableContainer.find('table');
                                let fixTable = $table.length && $table.find('thead th').length > noColumns;
                                fixTable = isMobile ? fixTable && $table.width() > (screen.width - 32) : fixTable;
                
                                if(fixTable) {
                                    const $tableFixed = $table.clone();
                                    $tableFixed.addClass('table-fixed');
                                    $fixedTableContainer.append($tableFixed);
                                    //$table.find('th').css('border-width', '0');
                                }
                            }
    
                            /*$('#pricelistTableModal, [id^=unitModal-]').on('shown.bs.modal', e => {
                            });*/
                    
                        }
                    } else {
                        $objectPricelistSpinner.addClass('d-none');
                        $objectPricelist.append(`
                            <div class="fw-bold text-danger">Cenovnik trenutno nije dostupan.</div>    
                        `);
                    }
                })
            }

        });

        $('#nav-bus-aranzmani-tab, #details-nav-bus-package-tab').on('shown.bs.tab', e => {
            const $target = $(e.currentTarget);
            let params = $('[id^=pricelistTableModal]').attr('data-params') ? JSON.parse($('[id^=pricelistTableModal]').attr('data-params')) : null;

            params.dynamicPackage = 2;

            const $objectPricelist = $('.object-pricelist-package-table');
            const $objectPricelistSpinner = $target.find('.object-pricelist-spinner');
 
            if(params && ! $objectPricelist.children().length) {
                $.get('/services/get_pricelists/', params).done(response => {
                    $objectPricelist.html(response);
                    $objectPricelistSpinner.addClass('d-none');

                    const $fixedTableContainer = $target.find('.add-table-fixed');
            
                    if($fixedTableContainer.length) {
                        const isMobile = functions.isMobile();
                        let noColumns = isMobile ? 2 : 10;
                
                        let isFixed = $fixedTableContainer.find('.table-fixed').length;
            
                        if(! isFixed) {
                            const $table = $fixedTableContainer.find('table');
                            let fixTable = $table.length && $table.find('thead th').length > noColumns;
                            fixTable = isMobile ? fixTable && $table.width() > (screen.width - 32) : fixTable;
            
                            if(fixTable) {
                                const $tableFixed = $table.clone();
                                $tableFixed.addClass('table-fixed');
                                $fixedTableContainer.append($tableFixed);
                                //$table.find('th').css('border-width', '0');
                            }
                        }

                        /*$('#pricelistTableModal, [id^=unitModal-]').on('shown.bs.modal', e => {
                        });*/
                
                    }
                })
            }
        });

        $('.details-cart').on('click', '[data-scroll-to]', e => {
            if (functions.isMobile()) {
                $('#collapseOne').collapse('hide');
            }
        })

        if(! +$('#booking').attr('data-dynamicpackage')) {
            const programURL = $('[data-programurl]').length ? $('[data-programurl]').attr('data-programurl') : null;
            if(programURL) {
                const $travelProgram = $('#travelProgram');
                $.get(programURL).done(response => {
                    response = JSON.parse(response);
                    if (response.status) {
                        $travelProgram.find('.travel-program-body').html(response.html);
                        $travelProgram.find('.btn-print-travel-program').attr('data-params', $(response.html).find('[data-print]:first').attr('data-print'));
    
                        $('.travel-program-link').removeClass('d-none');
                        $travelProgram.find('.btn-print-travel-program').removeClass('d-none');
                    } else {
                        $('.travel-program-link').addClass('d-none');
                        $travelProgram.find('.btn-print-travel-program').addClass('d-none');
                    }
                }).fail(e => {
                    $('.travel-program-link').addClass('d-none');
                    $travelProgram.find('.btn-print-travel-program').addClass('d-none');
                });
            }
        }

        $('#travelProgram').on('click', '.btn-print-travel-program', e => {
            const $modalContent = $('#travelProgram').find('.travel-program-body');
            const modalContent = $modalContent[0];
            const $head = $('head');
            const head = $head[0];
    
            let htmlToPrint = head.outerHTML + '<style>@page { size:  auto; margin-top: 60px; margin-bottom: 60px; }</style>' + '<body>' + modalContent.outerHTML + '</body>';
            let windowToPrint = window.open("");
    
            windowToPrint.document.write(htmlToPrint);
            setTimeout(() => {
                windowToPrint.print();
                windowToPrint.close();
            }, 500);
        });

    },
    getParams(params, defaults = {}) {
        return $.extend({}, params, defaults, functions.getUrlData(true));
    },
    isBookable(data) {
        return (data.booking.status == 'Request' || data.booking.status == 'Reservation') && data.isAvailable && data.calc.status == 'Active';
        //return data.booking.status == 'Request' || data.booking.status == 'Reservation';
    },
    isBookablePerService(services) {
        let isBookable = false;
        Object.entries(services).forEach(service => {
            const data = service[1];
            if ((data.booking.status === 'Request' || data.booking.status === 'Reservation') && data.calc.status === 'Active') {
                isBookable = true;
            }
        });
        return isBookable;
    },
    getMinPricePerService(services) {
        let min = null;
        Object.entries(services).forEach(service => {
            const data = service[1];
            if (min === null || +data.calc.total < min) {
                min = +data.calc.total;
            }
        });
        return min.toFixed(2);
    },
    getCalcErrorMessage(messages, data) {
        if(messages && data.calc && data.calc.message && data.calc.message.type) {
            return messages[data.calc.message.type] ? messages[data.calc.message.type].replace('{$condition}', (data.calc.message.condition_full ? data.calc.message.condition_full : data.calc.message.condition)) : null;
        }
        else if (data.message && messages && messages[data.message]) {
            return messages[data.message] ? messages[data.message].replace('{$condition}', data.condition) : null;
        }
        return messages ? messages.general : null;
    },
    getCalculation(params) {
        const objectGroupId = params.objectGroupId;
        const objectId = params.objectId;
        const unitId = params.unitId;
        const dateFrom = params.dateFrom;
        //const dateTo = params.dateTo ? params.dateTo : (params.objectGroupId !== 1 ? null : dateFrom);
        const dateTo = params.dateTo;
        const guests = params.guests && params.guests.startsWith('0') ? null : params.guests;
        const dynamicPackage = params.dynamicPackage;
        const pricelistId = params.pricelistId;
        const optionals = params.optionals;
        const serviceCode = params.serviceCode ? encodeURIComponent(params.serviceCode) : null;
        const aDateFrom = params.aDateFrom || null;
        const aDateTo = params.aDateTo || null;
        const transportUnitId = params.transportUnitId || null;
        const placeFromId = params.placeFromId || 0;
        const time = params.time || null;
        const calcPerService = params.calcPerService || 0;
        const currencyIdTo = params.currencyIdTo || 1;

        if(
            (objectId || unitId)
            && guests
            && dateFrom
            && dateTo
            && objectGroupId
        ) {
            return $.getJSON(
                location.protocol
                + '//'
                + location.hostname
                + '/services/calc/'
                + (unitId ? '?unitId=' + unitId : '?publicId=' + objectId)
                + '&guests=' + guests
                + '&dateFrom=' + dateFrom
                + '&dateTo=' + dateTo
                + '&objectGroupId=' + objectGroupId
                + '&language=' + functions.getLang()
                + (dynamicPackage ? '&dynamicPackage=' + dynamicPackage : '')
                + (pricelistId ? '&pricelistId=' + pricelistId : '')
                + (optionals ? '&optionals=' + optionals : '')
                + (serviceCode ? '&serviceCode=' + serviceCode : '')
                + (aDateFrom ? '&aDateFrom=' + aDateFrom : '')
                + (aDateTo ? '&aDateTo=' + aDateTo : '')
                + (transportUnitId ? '&flightUnitId=' + transportUnitId : '')
                + (placeFromId ? '&placeFromId=' + placeFromId : '')
                + (time ? '&time=' + time : '')
                + (calcPerService ? '&calcPerService=1' : '')
                + (currencyIdTo ? '&currencyIdTo=' + currencyIdTo : '')
                + '&addAllOptionals=true'
            );
        } else {
            return null;
        }

    },
    getCalcTotalOld(calcItems) {
        let priceOld = 0;

        calcItems.forEach(item => {
            // popust za djecu ne ulazi u prikaz discount cijene
            if((item.itemType != 'discount' || item.itemDefinitionId == 129) && !item.optional && !item.onSpot) {
                priceOld += item.itemTotal;
            }
        });

        return priceOld;
    },
    getCalcDiscountTitle(calcItems) {

        let discountTitle = null

        calcItems.forEach(item => {
            if(item.itemType == 'discount') {
                discountTitle = item.itemTitle;
                if(item.data && item.data.text) {
                    discountTitle = item.data.text;
                }
            }
        });
        
        return discountTitle;
    },
    unitsSpinner() {
        $('.units-spinner').remove();
        let unitsSpinner = `<div class="units-spinner">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>`;
        $(unitsSpinner).insertBefore('.units')
        $('.units').removeClass('opacity-100');
        $('.units').addClass('opacity-0');

        setTimeout(() => {
            $('.units-spinner').remove();
            $('.units').addClass('opacity-100');
            $('.units').removeClass('opacity-0');
        }, 800);
    },
    /*loader($target = null) {
        $target ? $target.addClass('active') : $('.unit-spinner').addClass('active');
        setTimeout(() => {
            $target ? $target.removeClass('active') : $('.unit-spinner').removeClass('active');
        }, 800);
    },*/
};

export {
    details,
};
